import React from 'react'
import { BsArrowRightShort } from 'react-icons/bs'
import { usePlaidLink } from 'react-plaid-link';
import StripeCheckout from 'react-stripe-checkout';
import { toast } from 'react-toastify';
import { CreatePaymentIntent } from '../API/BankTransactionAPI';

const BankDetails = ({setStep, setMainStep, bankDetail, setBankDetail, isUpdate, setData }) => {

    const handleContinue = () => {
        if(isUpdate){
            setMainStep('step5');
            setStep('Summary');
            setData('default')
        } else {
            setMainStep('step3')
            setStep('varification')
        }
    }

    const { open, ready } = usePlaidLink({
        token: 'link-sandbox-b0c86dff-2357-4931-97ee-b9c1ac2dbebd',
        onSuccess: (public_token, metadata) => {
          setBankDetail({
            routing_number: metadata.account_id,
            account_number: metadata.account_id,
            confirm_account_number: metadata.account_id
          })
        },
    });
    
    const onPay = async (token) => {
        try{
            const response = await CreatePaymentIntent(token)
            if(response.statusText === 'OK'){
                toast.success("Paymnet successfully done", { autoClose: 5000 });
            }

        }catch(err){
            toast.error(err.message, { autoClose: 5000 });
        }
    }

    return (
        <div>
            <div>
                <h3 className='text-[#30313d] sm:text-[32px] text-[24px] font-semibold leading-[36px]'>Add your bank to receive payouts</h3>
                <p className='text-[#414552] mt-2'>A payout is the transfer of funds from Stripe to your bank account.</p>
            </div>
            <div className='sm:mt-[40px] mt-[20px]'>

                <StripeCheckout
                    stripeKey={process.env.REACT_APP_PUBLISHABLE_KEY}
                    name="Payment"
                    description="Your total is $10" 
                    amount={1000}
                    token={onPay}
                    ComponentClass="div"
                />
                
                {/* <button onClick={() => open()} disabled={!ready} className="input_focus_shadow rounded-md flex items-center font-medium w-full gap-2 h-[36px] pl-2 pr-3 py-2 justify-center text-[#404552]">Select your bank</button> */}
                
                <div className='sm:mt-[32px] mt-[20px] group relative'>
                    <label htmlFor="routing-number" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>IFSC Code</label>
                    <div className="relative mt-1 w-full">
                        <input
                            onChange={(e) => setBankDetail({...bankDetail, routing_number: e.target.value})}
                            type='text' id="routing-number" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='HDFC0000261' />
                    </div>
                </div>
                <div className='sm:mt-[32px] mt-[20px] group relative'>
                    <label htmlFor="Account-number" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Account number</label>
                    <div className="relative mt-1 w-full">
                        <input
                            onChange={(e) => setBankDetail({...bankDetail, account_number: e.target.value})}
                            type='text' id="Account-number" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='000123456789' />
                    </div>
                </div>
                <div className='sm:mt-[32px] mt-[20px] group relative'>
                    <label htmlFor="Confirm-number" className='text-sm mb-1 cursor-pointer text-[#1a1b25] font-semibold'>Confirm account number</label>
                    <div className="relative mt-1 w-full">
                        <input
                            onChange={(e) => setBankDetail({...bankDetail, confirm_account_number: e.target.value})}
                            type='text' id="Confirm-number" className="input_focus_shadow text-[#404452] px-3 w-full bg-white font-normal rounded-[6px] focus:outline-none h-[36px] py-1 text-[14px]" placeholder='000123456789' />
                    </div>
                </div>

                <div className='mt-6 pb-5'>
                    <button onClick={handleContinue} className='rounded-md flex items-center gap-1 font-semibold w-full h-[36px] px-4 py-2 justify-center text-white bg-[#625afa]'>Continue<BsArrowRightShort className='text-[25px]' /></button>
                </div>
            </div>
        </div>
    )
}

export default BankDetails